<template>
    <div class="doc-section">
        <h1>Compartir Link para Rastreo</h1>
        <p>
            Esta funcionalidad permite generar un enlace temporal para que terceros puedan visualizar la ubicación en
            tiempo real de un dispositivo sin necesidad de acceder al sistema.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />


        <h2>Generar el Enlace</h2>
        <p>Desde la vista de <strong>Dispositivos</strong>:</p>
        <ul class="ul-contenedor step-list">
            <li>Localice el dispositivo que desea compartir.</li>
            <li>Haga clic en el botón <strong>Generar link</strong>. Se abrirá el formulario de configuración.</li>
        </ul>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="[imagenesLink[0]]" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="[imagenesLinkMoviles[0]]" />
        </div>



        <h2>Configuración de Vigencia</h2>
        <p>En el formulario podrá establecer el tiempo de vida del enlace:</p>
        <ul class="ul-contenedor step-list">
            <li><strong>Medida de tiempo:</strong> Seleccione entre Días, Horas o Minutos.</li>
            <li><strong>Cantidad:</strong> Ingrese el valor (Mínimo 1, Máximo 15 días).</li>
            <li><strong>Generar:</strong> Al dar clic, el sistema creará el enlace único.</li>
        </ul>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="[imagenesLink[1]]" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="[imagenesLinkMoviles[1]]" />
        </div>

        <h2>Copiar y Compartir</h2>
        <p>Una vez generado el enlace:</p>
        <ul class="ul-contenedor step-list">
            <li>El link aparecerá en el campo de texto inferior.</li>
            <li>Use el botón <strong>Copiar link</strong> para guardarlo en el portapapeles automáticamente.
            </li>
        </ul>
        <CarruselAciqui :items="[imagenesLink[3]]" />

        <h2>Estados del Enlace</h2>
        <p>Al abrir el enlace en un navegador, se pueden presentar los siguientes escenarios:</p>

        <div class="info-grid">
            <div class="card">
                <p><strong>✅ Link Válido:</strong> Se muestra el mapa con el dispositivo moviéndose en tiempo real.</p>
            </div>
            <div class="card">
                <p><strong>⚠️ Link Inválido:</strong> Si el tiempo expira mientras se visualiza, aparecerá un mensaje de
                    "Acceso inválido".</p>
            </div>
            <div class="card">
                <p><strong>🚫 Error 404:</strong> Si el link es incorrecto o ya caducó antes de abrirlo, se mostrará
                    "Página no encontrada".</p>
            </div>
        </div>


        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesLink.slice(4, 7)" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesLinkMoviles.slice(4, 7)" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'CompartirLink',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesLink: [
            { nombre: "", url: "img/Dispositivos/botonGenerarLink.png" },
            { nombre: "", url: "img/Dispositivos/formularioCompartirLink.png" },
            { nombre: "Notificación Éxito", url: "img/Dispositivos/exitoGenerarLink.png" },
            { nombre: "", url: "img/Dispositivos/notificacionLinkCopiado.png" },
            { nombre: "Vista en Tiempo Real", url: "img/Dispositivos/vistaLinkCompartido.png" },
            { nombre: "Link inválido", url: "img/Dispositivos/linkInvalidio.png" },
            { nombre: "Error 404", url: "img/Dispositivos/linkCaducado.png" }
        ],
        imagenesLinkMoviles: [
            { nombre: "", url: "img/Dispositivos/moviles/botonGenerarLink.png" },
            { nombre: "", url: "img/Dispositivos/moviles/formularioCompartirLink.png" },
            { nombre: "Notificación Éxito", url: "img/Dispositivos/exitoGenerarLink.png" },
            { nombre: "", url: "img/Dispositivos/notificacionLinkCopiado.png" },
            { nombre: "Vista en Tiempo Real", url: "img/Dispositivos/moviles/vistaLinkCompartido.png" },
            { nombre: "Link inválido", url: "img/Dispositivos/linkInvalidio.png" },
            { nombre: "Error 404", url: "img/Dispositivos/linkCaducado.png" }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>